import AccActionExportForm from "lib/hex/views/AccActionExportForm";
import AccAFibExportForm from "lib/hex/views/AccAFibExportForm";
import AccCathPciExportForm from "lib/hex/views/AccCathPciExportForm";
import AccIcdExportForm from "lib/hex/views/AccIcdExportForm";
import AccImpactExportForm from "lib/hex/views/AccImpactExportForm";
import AccPVIExportForm from "lib/hex/views/AccPVIExportForm";
import AdultCardiacExportForm from "lib/hex/views/AdultCardiacExportForm";
import AdultCardiacHarvestForm from "lib/hex/views/AdultCardiacHarvestForm";
import CongenitalExportForm from "lib/hex/views/CongenitalExportForm";
import CongenitalHarvestForm from "lib/hex/views/CongenitalHarvestForm";
import GenericXmlExportForm from "lib/hex/views/GenericXmlExportForm";
import StsAccTvtExportForm from "lib/hex/views/StsAccTvtExportForm";

const formRegistry = {
    "acc-action-export": AccActionExportForm,
    "acc-afib-export": AccAFibExportForm,
    "acc-cathpci-export": AccCathPciExportForm,
    "acc-icd-export": AccIcdExportForm,
    "acc-impact-export": AccImpactExportForm,
    "acc-pvi-export": AccPVIExportForm,
    "adult-cardiac-export": AdultCardiacExportForm,
    "adult-cardiac-harvest": AdultCardiacHarvestForm,
    "congenital-export": CongenitalExportForm,
    "congenital-harvest": CongenitalHarvestForm,
    "generic-xml": GenericXmlExportForm,
    "sts-acc-tvt-export": StsAccTvtExportForm,
};

export function registerForm(key, formComponent) {
    formRegistry[key] = formComponent;
}

export default formRegistry;



// WEBPACK FOOTER //
// ./app/lib/hex/views/formRegistry.js